export default __webpack_public_path__ + "static/media/48_BottomLeftSquares_Top.00e29a04.mp4";